export const defaultSite = 2;

const enExp = /^(?:\/)?(?:en)(?:\/|$)/;

const cnExp = /^(?:\/)?(?:cn)(?:\/|$)/;

export function getSite(url?: string | null) {

  let siteId = defaultSite;
  if (!url) return siteId;

  if (enExp.test(url)) {
    return 2
  }

  return siteId;
}

/** 获取link前缀 */
export function getRoutePrefix(_site?: number | string | null) {
  const site = _site ? Number(_site) : getSite();
  switch (site) {
    case 1:
      return "/cn";
    case 2:
      return "/";
    default:
      return "";
  }
}

export const defaultLang = 1;
export function getLang(url?: string | null) {
  let lang = 2;
  if (!url) return lang;

  if (enExp.test(url)) {
    return 2
  }

  return lang;
}

export const defaultLocale = "en";
export function getLocale(url?: string | null) {
  const path = url?.replace(/^(?:https?:\/\/[^\/]+)/, "");

  let locale = defaultLocale;
  if (!path) return locale;

  if (enExp.test(path)) {
    locale = "en";
  }

  return locale;
}
